import React from "react";

import Button from "../ui/Button";
import Card from "../ui/Card";

const pageStyle: React.CSSProperties = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "var(--mobile-page-padding)",
  background: "var(--background)",
  color: "var(--text-primary)",
};

const contentStyle: React.CSSProperties = {
  width: "100%",
  maxWidth: "var(--content-max-width-sm)",
};

const cardStyle: React.CSSProperties = {
  textAlign: "center",
};

const brandStyle: React.CSSProperties = {
  margin: "0 0 24px",
  color: "var(--primary)",
  fontSize: "14px",
  fontWeight: 800,
  letterSpacing: "0.16em",
  textTransform: "uppercase",
};

const titleStyle: React.CSSProperties = {
  margin: "0 0 12px",
  color: "var(--text-primary)",
  fontSize: "28px",
  lineHeight: 1.2,
};

const descriptionStyle: React.CSSProperties = {
  margin: "0 0 24px",
  color: "var(--text-secondary)",
  fontSize: "15px",
  lineHeight: 1.6,
};

const helperStyle: React.CSSProperties = {
  margin: "16px 0 0",
  color: "var(--text-secondary)",
  fontSize: "13px",
  lineHeight: 1.5,
};

const MobileWebNotice = () => {
  return (
    <div style={pageStyle}>
      <div style={contentStyle}>
        <Card style={cardStyle}>
          <p style={brandStyle}>LYNX</p>

          <h1 style={titleStyle}>Continuá desde la app</h1>

          <p style={descriptionStyle}>
            Lynx Web está optimizado para computadoras. Para operar desde el
            teléfono, utilizá la aplicación móvil de Lynx.
          </p>

          <Button fullWidth disabled>
            Descargar app
          </Button>

          <p style={helperStyle}>
            La descarga estará disponible próximamente.
          </p>
        </Card>
      </div>
    </div>
  );
};

export default MobileWebNotice;